import { validateResponse, checkResponseError } from "../lib/validateResponse";
import { oneError, ValidationErrors } from "../lib/validationAllFields";
import { SET_ENTIIY_FIELD, SER_SEARCH_FIELD } from "../lib/entitiesReducer";
import { normalize, arrayOf } from "normalizr";
import { galleryItem } from "../app/schema";

export const PATCH_GALLERY_ITEM = "PATCH_GALLERY_ITEM";
export const DELETE_GALLERY_ITEM = "DELETE_GALLERY_ITEM";

export const SET_IS_EDIT_GALLERY_ITEM_MODAL_VISIBLE =
  "SET_IS_EDIT_GALLERY_ITEM_MODAL_VISIBLE";
export const SET_IS_REMOVE_GALLERY_ITEM_MODAL_VISIBLE =
  "SET_IS_REMOVE_GALLERY_ITEM_MODAL_VISIBLE";

// Requests

const patchGalleryItem = (fetch, apiHost, accessToken, uid, data) =>
  fetch(`${apiHost}/v1/gallery-items/${uid}`, {
    body: JSON.stringify(data),
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "PATCH"
  }).then(response => {
    return validateResponse(response, {});
  });

const deleteGalleryitem = (fetch, apiHost, accessToken, uid) =>
  fetch(`${apiHost}/v1/gallery-items/${uid}`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json"
    },
    method: "DELETE"
  }).then(response => {
    return validateResponse(response, {
      validation_error: {
        msg:
          "Nie można usunąć danych elementu galerii, ponieważ są one używane przez inne zasoby.",
        field: "all"
      }
    });
  });

export function updateGalleryItem(data, uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [PATCH_GALLERY_ITEM],
    payload: {
      promise: patchGalleryItem(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid,
        data
      )
        .then(data => {
          return normalize(data, galleryItem);
        })
        .catch(err => {
          let error = checkResponseError(err);
          throw error;
        })
    }
  });
}

export function removeGalleryItem(uid) {
  return ({ fetch, validate, config, users, msg }) => ({
    type: [DELETE_GALLERY_ITEM],
    payload: {
      promise: deleteGalleryitem(
        fetch,
        config().apiHost,
        users().viewer.accessToken,
        uid
      ).catch(err => {
        let error = checkResponseError(err);
        throw error;
      }),
      data: {
        uid
      }
    }
  });
}

export function setIsEditGalleryItemModalVisible(value) {
  return {
    type: SET_IS_EDIT_GALLERY_ITEM_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}

export function setIsRemoveGalleryItemModalVisible(value) {
  return {
    type: SET_IS_REMOVE_GALLERY_ITEM_MODAL_VISIBLE,
    payload: {
      isVisible: value
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/galleryItems/actions.js